import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

type Input = { driverId: string; vehicleId: string };

const patchVehicleForDriver = ({ driverId, vehicleId }: Input) =>
  driverApi.patch<void, void>(`/v1/driver/${driverId}/vehicle/${vehicleId}`);

export const usePatchVehicleForDriver = () =>
  useMutation<void, unknown, Input>({
    mutationFn: patchVehicleForDriver,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(queryKeys.user.fetchVehiclesForDriver(variables.driverId));
    },
  });
